import { SidebarMenuGroupConfig } from './sidebar.models';

export const SIDEBAR_MENU_GROUPS: SidebarMenuGroupConfig[] = [
  {
    id: 'start',
    label: 'Start',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: 'pi pi-home',
        route: '/home',
        routeKey: 'dashboard',
        matchMode: 'exact',
      },
    ],
  },
  {
    id: 'management',
    label: 'Zarządzanie',
    items: [
      {
        id: 'developers',
        label: 'Deweloper',
        icon: 'assets/icons/developer-icon.svg',
        route: '/home/developer',
        routeKey: 'developers',
        matchMode: 'prefix',
      },
      {
        id: 'investments',
        label: 'Moje inwestycje',
        icon: 'pi pi-building',
        route: '/home/investments',
        routeKey: 'investments',
        matchMode: 'prefix',
      },
      {
        id: 'media-library',
        label: 'Biblioteka mediów',
        icon: 'pi pi-images',
        route: '/home/media',
        routeKey: 'media',
        matchMode: 'prefix',
      },
    ],
  },
  {
    id: 'integrations',
    label: 'Integracje',
    items: [
      {
        id: 'gov',
        label: 'GOV',
        icon: 'pi pi-shield',
        route: '/home/gov',
        routeKey: 'gov',
        matchMode: 'prefix',
      },
      {
        id: 'wp-sites',
        label: 'Integracje i API',
        icon: 'assets/icons/www-icon.svg',
        route: '/home/wp-sites',
        routeKey: 'wp-sites',
        matchMode: 'prefix',
        subItems: [
          {
            id: 'wp-sites-integrations',
            label: 'Integracje',
            route: '/home/wp-sites/integrations',
            routeKey: 'wp-sites-integrations',
            matchMode: 'prefix',
          },
          {
            id: 'wp-sites-api-keys',
            label: 'Klucze API',
            route: '/home/wp-sites/api-keys',
            routeKey: 'wp-sites-api-keys',
            matchMode: 'prefix',
          },
        ],
      },
    ],
  },
  {
    id: 'system',
    label: 'System',
    items: [
      {
        id: 'users',
        label: 'Użytkownicy',
        icon: 'pi pi-users',
        route: '/home/users',
        routeKey: 'users',
        matchMode: 'prefix',
      },
    ],
  },
  {
    id: 'help',
    label: 'Pomoc',
    items: [
      {
        id: 'docs',
        label: 'Dokumentacja',
        icon: 'pi pi-book',
        route: '/home/docs',
        routeKey: 'docs',
        matchMode: 'prefix',
      },
    ],
  },
];
